/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Component, ContentChildren, ElementRef, QueryList, Renderer2} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {Signpost} from '../../popover/signpost/signpost';
import {HideableColumnService} from './providers/hideable-column.service';
export class DatagridCell {
/**
 * ******
 * \@property signpost
 * 
 * 
 * \@description
 * \@ContentChild is used to detect the presence of a Signpost in the projected content.
 * On the host, we set the .datagrid-signpost-trigger class on the cell when signpost.length is greater than 0.
 * 
 */
signpost: QueryList<Signpost>;
/**
 * \@property id
 * 
 * \@description 
 * An identifier for an instance of this cell that maps it to a specific column
 * 
 */
private _id: string;
/**
 * @param {?} value
 * @return {?}
 */
set id(value: string) {
        this._id = value;
        this.mapHideableColumn(this._id);
    }
private hiddenStateSubscription: Subscription;
/**
 * @param {?} hideableColumnService
 * @param {?} _el
 * @param {?} _renderer
 */
constructor(public hideableColumnService: HideableColumnService,
private _el: ElementRef,
private _renderer: Renderer2) {}
/**
 * @param {?} columnId
 * @return {?}
 */
private mapHideableColumn(columnId: string) {
        if (!columnId) {
            return;
        }

        const /** @type {?} */ hideableColumn = this.hideableColumnService.getColumnById(this._id);

        this.setHiddenClass(hideableColumn.hidden);
        this.hiddenStateSubscription = hideableColumn.hiddenChangeState.subscribe(() => {
            this.setHiddenClass(hideableColumn.hidden);
        });
    }
/**
 * @param {?} hideableColumnValue
 * @return {?}
 */
private setHiddenClass(hideableColumnValue: boolean) {
        if (hideableColumnValue) {
            this._renderer.addClass(this._el.nativeElement, "datagrid-cell--hidden");
        } else {
            this._renderer.removeClass(this._el.nativeElement, "datagrid-cell--hidden");
        }
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        if (this.hiddenStateSubscription) {
            this.hiddenStateSubscription.unsubscribe();
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-dg-cell",
    template: `
        <ng-content></ng-content>
    `,
    host: {"[class.datagrid-cell]": "true", "[class.datagrid-signpost-trigger]": "signpost.length > 0"}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: HideableColumnService, },
{type: ElementRef, },
{type: Renderer2, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'signpost': [{ type: ContentChildren, args: [Signpost, ] },],
};
}

function DatagridCell_tsickle_Closure_declarations() {
/** @type {?} */
DatagridCell.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatagridCell.ctorParameters;
/** @type {?} */
DatagridCell.propDecorators;
/**
 * ******
 * \@property signpost
 * 
 * 
 * \@description
 * \@ContentChild is used to detect the presence of a Signpost in the projected content.
 * On the host, we set the .datagrid-signpost-trigger class on the cell when signpost.length is greater than 0.
 * 
 * @type {?}
 */
DatagridCell.prototype.signpost;
/**
 * \@property id
 * 
 * \@description 
 * An identifier for an instance of this cell that maps it to a specific column
 * 
 * @type {?}
 */
DatagridCell.prototype._id;
/** @type {?} */
DatagridCell.prototype.hiddenStateSubscription;
/** @type {?} */
DatagridCell.prototype.hideableColumnService;
/** @type {?} */
DatagridCell.prototype._el;
/** @type {?} */
DatagridCell.prototype._renderer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
